module.exports = __webpack_public_path__ + "static/media/platform_section1.c882a9af.webp";